import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

import { formatCurrency } from 'shared/helpers/utils';

import Imgix from 'shared/components/imgix';

const OrderReceiptListItem = ({ item }) => {
  const { t } = useTranslation();
  const { product, quantity, option, price } = item;
  const { Image, Name, brandName } = product;

  return (
    <Container>
      <ImageContainer src={Image} height={51} />

      <ProductDetails>
        <ProductName>{Name}</ProductName>
        <ProductBrand>{brandName}</ProductBrand>
        <QuantityWeightContainer>
          <span>
            <span>{t('common.qty', 'qty:')}&nbsp;</span>
            {quantity}
          </span>

          <span>
            <span>{t('common.weight', 'weight:')}&nbsp;</span>
            {option}
          </span>
        </QuantityWeightContainer>
      </ProductDetails>

      <ProductPrice>{formatCurrency(price)}</ProductPrice>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding-top: 31px;
  padding-bottom: 20px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.blueGrey[90]}`};

  &:last-child {
    border: none;
  }
`;

const ImageContainer = styled(Imgix)`
  min-width: 72px;
  margin-right: 15px;
`;

const ProductDetails = styled.div`
  flex: 1;
`;

const ProductName = styled.div`
  font-size: 14px;
  padding-right: 15px;
  font-weight: bold;
  line-height: 120%;
  flex: 1;
`;

const ProductBrand = styled.div`
  margin-top: 5px;
  font-size: 12px;
  line-height: 165%;
`;

const QuantityWeightContainer = styled.div`
  display: flex;
  margin-top: 5px;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.grey[45]};
  line-height: 150%;

  > span {
    margin-right: 15px;

    > span {
      font-weight: bold;
      text-transform: uppercase;
    }
  }
`;

const ProductPrice = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.grey[30]};
  min-width: 43px;
`;

export default OrderReceiptListItem;
